<p>safe-menu works!</p>
